<template>
  <div>
    <lead-custom-fields></lead-custom-fields>
    <lead-bulk-delete v-if="authUserIsOwner"></lead-bulk-delete>
  </div>
</template>

<script>
import LeadCustomFields from "./components/LeadCustomFields";
import LeadBulkDelete from "./components/LeadBulkDelete";

export default {
  name: "LeadsTab",
  components: {
    LeadBulkDelete,
    LeadCustomFields
  },
  computed: {
    authUserIsOwner() {
      return this.$store.getters.authUser.is_owner;
    },
  }
}
</script>
